export default __webpack_public_path__ + "static/media/confirm.07da6c55.svg";